import React from 'react';


module.exports = (props) => {
  return (
    <div
      {...props}
      className={'ff$3 bgF r16 p45 ph60 p20@m3 wmax rlv ov ' + (props.className || '')}
    />
  );
};
